import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'
import I18n from 'i18n-js'
import moment from 'moment'
import { PropTypes } from 'prop-types'

import formikConnect from '@src/lib/formikConnect'

import { formatWithoutCents } from '../../../lib/Utils'
import PlatformAvatarGroup from '../../reporting/PlatformAvatarGroup'
import LegacySvg from '../../shared/LegacySvg'
import AutomationBrandFacebookPageCheckbox from '../AutomationBrandFacebookPageCheckbox'

const calculateDays = (start, end) => {
  return moment(end).diff(moment(start), 'days')
}

const ActivationCompletePaidAd = (props) => {
  return (
    <Grid container justifyContent="center">
      <Grid item lg={6} md={8} xs={12}>
        <Box textAlign="center">
          <Typography variant="h5">
            {I18n.t('content.premiumPaidAdActivated')}
          </Typography>
          <Typography
            color="textSecondary"
            variant="h6"
          >{`${props.brand.name}: ${props.campaign.title}`}</Typography>
        </Box>
        <br />
        <br />
        <List>
          <Divider component="li" />
          <ListItem divider>
            <ListItemIcon>
              <LegacySvg height={'1.5em'} symbol={'social'} width={'1.5em'} />
            </ListItemIcon>
            <ListItemText
              primary={I18n.t('content.activatedChannels', {
                count: props.campaign.platforms.length,
              })}
            />
            <ListItemSecondaryAction>
              <PlatformAvatarGroup platforms={props.campaign.platforms} />
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem divider>
            <ListItemIcon>
              <LegacySvg
                height={'1.5em'}
                symbol={'dollarsign'}
                width={'1.5em'}
              />
            </ListItemIcon>
            <ListItemText
              primary={I18n.t('content.premiumPaidConfirmAmount', {
                amount: formatWithoutCents.format(
                  props.campaign.campaign_invitation.intended_amount_cents /
                    100,
                ),
                brand: props.brand.name,
              })}
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <LegacySvg height={'1.5em'} symbol={'calendar'} width={'1.5em'} />
            </ListItemIcon>
            <ListItemText
              primary={I18n.t('content.premiumPaidConfirmDates', {
                count: calculateDays(
                  props.campaign.starts_at,
                  props.campaign.ends_at,
                ),
                startDate: moment(props.campaign.starts_at).format(
                  'MM/DD/YYYY',
                ),
                endDate: moment(props.campaign.ends_at).format('MM/DD/YYYY'),
              })}
            />
          </ListItem>
          <Divider component="li" />
        </List>
        <br />
        <br />
        <Grid container justifyContent="center">
          <Grid item md={8} xs={10}>
            <Typography color="textSecondary" variant="body2">
              {I18n.t('automations.activationUpsell')}
            </Typography>
            <AutomationBrandFacebookPageCheckbox
              brandId={props.brand.id}
              facebookPageId={props.formik.values.facebookPageId}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

ActivationCompletePaidAd.propTypes = {
  brand: PropTypes.object,
  campaign: PropTypes.object,
}

export default formikConnect(ActivationCompletePaidAd)
